<div class="card">
    <div class="card-body">
        <div class="mb-4">
            <h3><i class="fa-solid fa-users me-2"></i>Räume <small class="text-muted">({{totalEntries()}})</small></h3>
        </div>

        <pagination
            [hidden]="entries().length == 0"
            [totalItems]="totalEntries()"
            [itemsPerPage]="paginConfig.itemsPerPage"
            [(ngModel)]="paginConfig.page"
            (pageChanged)="listEntries($event)"
            [maxSize]="20"
            previousText="Letzte"
            nextText="Nächste">
        </pagination>

        <div class="table-responsive">
            <table class="table table-striped table-hover pointer mb-0">
                <thead>
                <tr>
                    <th style="width: 100px" (click)="setOrder('client')">
                        Mandant
                        @if (predicate() == 'client') {
                            <i class="fa-solid" [class.fa-arrow-up]="!reverse()" [class.fa-arrow-down]="reverse()"></i>
                        }
                    </th>
                    <th (click)="setOrder('topic')">
                        Thema
                        @if (predicate() == 'topic') {
                            <i class="fa-solid" [class.fa-arrow-up]="!reverse()" [class.fa-arrow-down]="reverse()"></i>
                        }
                    </th>
                    <th (click)="setOrder('date')">
                        Datum
                        @if (predicate() == 'date') {
                            <i class="fa-solid" [class.fa-arrow-up]="!reverse()" [class.fa-arrow-down]="reverse()"></i>
                        }
                    </th>
                    <th (click)="setOrder('creator')">
                        Ersteller
                        @if (predicate() == 'creator') {
                            <i class="fa-solid" [class.fa-arrow-up]="!reverse()" [class.fa-arrow-down]="reverse()"></i>
                        }
                    </th>
                    <th>
                        Teilnehmer
                    </th>
                    <th (click)="setOrder('created_at')">
                        Erstellt am
                        @if (predicate() == 'created_at') {
                            <i class="fa-solid" [class.fa-arrow-up]="!reverse()" [class.fa-arrow-down]="reverse()"></i>
                        }
                    </th>
                </tr>
                </thead>
                <tbody>
                @for (entry of entries(); track entry.id) {
                    <tr>
                        <td>{{ entry.client }}</td>
                        <td>{{ entry.topic }}</td>
                        <td>{{ entry.date | date: 'dd.MM.yyyy HH:mm' }}</td>
                        <td>{{ entry.creator }}</td>
                        <td>{{ entry.participants }}</td>
                        <td>{{ entry.created_at | date: 'dd.MM.yyyy HH:mm' }}</td>
                    </tr>
                }
                </tbody>
            </table>
        </div>
    </div>
</div>
